/// <amd-module name="Repos/RepoDropdown/GitRepositoryService" />
import { GitRepository } from "Repos/Common/Contracts/Git";
import { IReadyableReadonlyObservableArray, ReadyableObservableArray } from "VSS/Core/Observable";
import { IVssService, Services, VssService } from "VSS/Platform/Context";
import { getGitClient } from "./RestClient/Git";

/**
 * Service for working with git repositories
 */
export interface IGitRepositoryService extends IVssService {
    /**
     * Get all the git repositories in the collection or project
     *
     * @param projectId If specified, get the repositories only in the specified project
     */
    getAllRepositories(projectId?: string): IReadyableReadonlyObservableArray<GitRepository>;
}

class GitRepositoryService extends VssService implements IGitRepositoryService {
    private repositoriesByProject: { [project: string]: ReadyableObservableArray<GitRepository> } = {};

    public getAllRepositories(projectId?: string): IReadyableReadonlyObservableArray<GitRepository> {
        let repositories = this.repositoriesByProject[projectId || ""];
        if (!repositories) {
            repositories = new ReadyableObservableArray<GitRepository>();
            const gitClient = getGitClient(this.pageContext);
            gitClient.getRepositories(projectId).then(repos => {
                repositories.value = repos;
                repositories.ready.value = true;
            });
            this.repositoriesByProject[projectId || ""] = repositories;
        }
        return repositories;
    }
}

Services.add("IGitRepositoryService", { serviceFactory: GitRepositoryService });
